import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import { ReservationService } from "../services/reservation-service/reservation.service";
import { UserServiceService } from "../services/user-service/user-service.service";
import { environment } from "./../../environments/environment";
import { LeadsService } from "./../services/lead-service/lead-service.service";
import { ProjectsService } from "./../services/projects/projects.service";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { r } from "@angular/core/src/render3";

@Component({
  selector: "app-reservation",
  templateUrl: "./reservation.component.html",
  styleUrls: ["./reservation.component.css"],
  providers: [ReservationService],
})
export class ReservationComponent implements OnInit {
  pagination: any = [];
  totalRec: number;
  reservations: Array<any> = [];
  inreservations = null;
  filesForm: FormGroup;
  file_name: any;
  file_name2: any;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  last_page_url: any;
  prev_page_url: any;
  current_page: any;
  excel: any;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;
  arrSearch: any = [];
  dataFromSearch: any;
  filterAgentByWordText: any;
  chosenAgent: any;
  units_reservation_modal_data: any;
  installmentForm: FormGroup;
  installmentMethods: any = [
    "7 Years 15% D.P and 85% over 25 ins. WWNC",
    "6 Years 10% D.P and 90% over 22 ins. WWNC",
    "5 Years 5% D.P and 95 % over 19 ins. WWNC",
    "6 years",
    "6 years overseas",
    "7.5 years",
    "7.5 years cityscape",
    "7.5 years overseas",
  ];
  installmentDays: any = [5, 10, 15, 20, 25, 28];
  is_refreshing = false;
  doc_type_installment_modal: any = ["PDF", "Excel"];
  is_installment_modal_loading = false;
  payments_option = ["Quarter", "Semi-annual", "Annual"];
  commentReservation: any;
  signature_date: any;
  selling_price: any;
  per_page: any;
  total: any;
  page: number = 1;
  page_length: number = 15;
  reservation_raw_data: any;
  reservation = {
    onColor: "primary",
    offColor: "danger",
    onText: "Enable",
    offText: "Disable",
    value: "",
    size: "",
  };
  selling_date: any;
  is_edit_mode_account_approve = false;
  last_price: any;
  cfo_pin: any;
  uploadExcel: FormGroup;
  lg = "lg";
  leadArrSerach: any;
  chosenLead: any;
  chosenLeadID: any;
  chosenLeadName: any;
  chosenLeadReason: any;
  chosenLeadPhone: any;
  allStatus: any = [
    // 'Contractor Approved',
    // conflict
    "Cheque Received",
    "Cancelled",
    "Declined",
  ];
  projects: any;
  paymentPlans: any[] = [];
  agent_excel: any;

  agents: any;
  teams: any[] = [];

  agentsDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  statusesDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  overseasDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  chequesDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  statusesOptions = [
    { id: 1, name: "Contracted" },
    { id: 2, name: "Not Contracted" },
    { id: 3, name: "New Reservation" },
    { id: 4, name: "Accountant Approved" },
    { id: 5, name: "Pending Finance Action" },
    { id: 6, name: "Cancelled" },
    { id: 7, name: "Declined" },
    { id: 8, name: "Refund-Transfer" },
    { id: 9, name: "Transfer To Another Unit" },
    { id: 10, name: "Refund-Termination" },
    { id: 11, name: "Termination" },
    { id: 12, name: "Refund-Return To Company" },
    { id: 13, name: "Return To Company" },
    { id: 14, name: "Refund-Customer Cancelled" },
    { id: 15, name: "Ready For Transfer To Another Unit" },
    { id: 16, name: "Pending Finance Refund Transfer" },
    { id: 17, name: "Refund-Transfer Process" },
    { id: 18, name: "Refund-Termination Process" },
    { id: 19, name: "Refund-Return To Company Process" },
    { id: 20, name: "Refund-Customer Cancelled Process" },
    { id: 21, name: "Refund-Contracted Transfer" },
    { id: 22, name: "Refund-Contracted Transfer Process" },
    { id: 23, name: "Ready For Transfer To Contracted Unit" },
    { id: 24, name: "Pending Finance Refund Contracted Transfer" },
    { id: 25, name: "Transfer To Contracted Unit" },
  ];

  overseasOptions = [
    {
      id: 1,
      name: "Yes",
    },
    {
      id: 2,
      name: "No",
    },
  ];

  chequesOptions = [
    {
      id: 1,
      name: "Yes",
    },
    {
      id: 2,
      name: "No",
    },
  ];

  contractOptions = [
    {
      id: 1,
      name: "pending",
    },
    {
      id: 2,
      name: "contract-sent",
    },
    {
      id: 3,
      name: "contract-signed",
    },
    {
      id: 4,
      name: "contract-approved",
    },
    {
      id: 5,
      name: "contract-delivered",
    },
  ];

  contractTypeOptions = [
    {
      id: "sale",
      name: "Sale",
    },
    {
      id: "rent",
      name: "Rent",
    },
  ];

  grantCommissionOptions = [
    {
      id: "Null",
      name: "-",
    },
    {
      id: "Yes",
      name: "Yes",
    },
    {
      id: "No",
      name: "No",
    },
  ];

  BooleanOptions = [
    {
      id: 1,
      name: "yes",
    },
    {
      id: 0,
      name: "no",
    },
  ];

  allEvents = [];
  allBrokers = [];
  reservationSummaryStats: any = {
    title: "Sold Units",
    cards: [
      { label: "Total Units Price", value: "-" },
      { label: "Total sold units", value: "-" },
      { label: "Total BUA", value: "-" },
      { label: "Average Units Meter Price", value: "-" },
    ],
  };
  //     formControlName="contractStatus"
  //     id="contractStatus">
  //     <option value="" disabled="true"
  //         [selected]="true">Contract Status
  //     </option>
  //     <option value="">All</option>
  //     <option value="pending">Contract Pending
  //     </option>
  //     <option value="contract-sent">Contract sent
  //     </option>
  //     <option value="contract-signed">Contract signed</option>
  //     <option value="contract-approved">Contract approved</option>
  //     <option value="contract-delivered">Contract Delivered </option>
  //     <option value="done">Done</option>
  // </select> -->

  filter_collapsed = true;

  selectedAgents: any = [];
  selectedStatuses: any = [];
  selectedContractStatuses: any = [];
  selectedContractTypes: any = [];
  selectedGrantCommissions: any = [];
  selectedDeposits: any = [];
  selectedCommissioned: any = [];
  selectedReservationFormSigned: any = [];
  selectedCollectedDownPayment: any = [];
  selectedBankTransfer: any = [];
  selectedProjects: any = [];
  selectedOverseas: any = [];
  selectedEvent_ids: any = [];
  selectedCheques: any = [];
  selectedBrokers: any = [];
  selectedPaymentPlans: any = [];
  selectedTeams: any = [];

  filterLeadObservable = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    if (keyword) {
      return this.http
        .get(`${baseUrl}users/search?keyword=${keyword}`)
        .map((res: any) => {
          console.log(res.length);
          if (res.length == 0) {
            return Observable.of([]);
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.name);
            });
            console.log(this.arrSearch);
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  valueChanged(event) {
    this.dataFromSearch.forEach((e) => {
      if (e.name == event) this.chosenAgent = e;
    });
  }

  constructor(
    private reservationService: ReservationService,
    private router: Router,
    private route: ActivatedRoute,
    public fb: FormBuilder,
    public slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    public leadsService: LeadsService,
    private http: HttpClient,
    public projectService: ProjectsService,
    private userService: UserServiceService
  ) {
    console.log(this.userProfile.role);
    this.createForms();
    console.log("--------------reloading", this.route.snapshot.queryParams);
    if (
      [
        "serial",
        "rf_serial",
        "lead_name",
        "location",
        "project_id",
        "date_from",
        "date_to",
        "approve_refund_request_date_from",
        "approve_refund_request_date_to",
        "selectedAgents",
        "selectedStatuses",
        "selectedContractStatuses",
        "selectedContractTypes",
        "selectedGrantCommissions",
        "selectedDeposits",
        "selectedCommissioned",
        "selectedReservationFormSigned",
        "selectedBankTransfer",
        "selectedProjects",
        "selectedOverseas",
        "selectedEvent_ids",
        "selectedCheques",
        "selectedBrokers",
        "selectedPaymentPlans",
        "selectedTeams",
        "is_gift",
        "is_shareholder"
      ].some((f) => this.route.snapshot.queryParams[f])
    ) {
      this.filterReservations(false);
    } else {
      this.getreservations();
    }
    // console.log(this.userProfile);
    this.excel = `${
      environment.api_base_url
    }reservation/export?token=${window.localStorage.getItem("token")}`;
    this.agent_excel = `${
      environment.api_base_url
    }generate/reservations/pdf?token=${window.localStorage.getItem("token")}`;
  }

  ngOnInit() {
    this.createInstallment();
    this.getProjects();
    this.getPaymentPlans();
    this.getEvents();
    this.getAgents();
    this.getSubTeams();
    this.getAllBrokers();
  }

  getPaymentPlans() {
    this.userService.getAllPaymentTerms(1, 1000).subscribe(
      (res: any) => {
        this.paymentPlans = res && res.data ? res.data : [];
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getAllBrokers() {
    this.userService
      .getBorkers({ is_select_form: true })
      .subscribe((data: any) => {
        this.allBrokers = data;
      });
  }

  getEvents() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllEvents().subscribe(
      (res: any) => {
        this.allEvents = res;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getAgents() {
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        console.log(data);
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getSubTeams() {
    this.userService.getSubTeams().subscribe(
      (res: any) => {
        this.teams = Array.isArray(res) ? res : (res && res.data ? res.data : []);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  onSelectAllItems(field: string, items: any, key = "id") {
    this[field] = items.map((f) => "" + f[key]);
  }

  onClearAllItems(field: string) {
    this[field] = [];
  }

  getProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (res: any) => {
        this.projects = res;
      },
      (err) => console.log(err)
    );
  }

  getreservations() {
    console.log("--------*-*-*-sfetch data");
    this.reservations = null;
    this.is_refreshing = true;
    this.reservationService.getReservations().subscribe(
      (data: any) => {
        this.reservation_raw_data = data;
        console.log(this.reservation_raw_data);
        console.log(this.reservation_raw_data.last_page);
        this.pagination = [];
        this.last_page_url = data.last_page_url;
        this.current_page = 1;
        this.per_page = data.to;
        this.total = data.total;
        let selected = true;
        for (var i = 1; i <= data.last_page; i++) {
          if (i > 1) selected = false;
          this.pagination.push({ number: i, selected: selected });
        }
        this.totalRec = data.total;
        this.reservations = data.data;
        this.updateReservationSummaryStats(data);
        console.log(this.reservations);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => (this.is_refreshing = false)
    );
  }

  addreservation() {
    this.router.navigate(["./pages/reservations/add/", 0]);
  }

  editreservation(reservationid) {
    this.router.navigate(["./pages/settings/accounts/add/", reservationid]);
  }

  deletereservation(reservationid) {}

  parseArray(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === "string" && data.includes(",")) return data.split(",");
    else return [data];
  }

  createForms() {
    this.filesForm = this.fb.group({
      receipt: [null, Validators.required],
      signed: [null, Validators.required],
    });
    // conflict solved
    this.filterForm = this.fb.group({
      serial: [this.route.snapshot.queryParams.serial || ""],
      rf_serial: [this.route.snapshot.queryParams.rf_serial || ""],
      agents: [[]],
      lead_name: [this.route.snapshot.queryParams.lead_name || ""],
      location: [this.route.snapshot.queryParams.location || ""],
      contractStatus: [[]],
      contract_type: [[]],
      statuses: [[]],
      overseas: [[]],
      event_ids: [[]],
      cheques: [[]],
      project_id: [this.route.snapshot.queryParams.project_id || ""],
      // selling_date: [''],
      is_deposit: [[]],
      is_collect_down_payment: [[]],
      is_bank_transfer: [[]],
      date_from: [this.route.snapshot.queryParams.date_from || ""],
      date_to: [this.route.snapshot.queryParams.date_to || ""],
      is_gift: [this.route.snapshot.queryParams.is_gift || ""],
      is_shareholder: [this.route.snapshot.queryParams.is_shareholder || ""],
      approve_refund_request_date_from: [this.route.snapshot.queryParams.approve_refund_request_date_from || ""],
      approve_refund_request_date_to: [this.route.snapshot.queryParams.approve_refund_request_date_to || ""],
    });

    // caching
    this.selectedAgents = this.parseArray(
      this.route.snapshot.queryParams.selectedAgents
    );
    this.selectedStatuses = this.parseArray(
      this.route.snapshot.queryParams.selectedStatuses
    );
    this.selectedContractStatuses = this.parseArray(
      this.route.snapshot.queryParams.selectedContractStatuses
    );
    this.selectedContractTypes = this.parseArray(
      this.route.snapshot.queryParams.selectedContractTypes
    );
    this.selectedGrantCommissions = this.parseArray(
      this.route.snapshot.queryParams.selectedGrantCommissions
    );

    this.selectedDeposits = this.parseArray(
      this.route.snapshot.queryParams.selectedDeposits
    );
    this.selectedCommissioned = this.parseArray(
      this.route.snapshot.queryParams.selectedCommissioned
    );
    this.selectedReservationFormSigned = this.parseArray(
      this.route.snapshot.queryParams.selectedReservationFormSigned
    );
    this.selectedBankTransfer = this.parseArray(
      this.route.snapshot.queryParams.selectedBankTransfer
    );
    this.selectedProjects = this.parseArray(
      this.route.snapshot.queryParams.selectedProjects ||
        this.route.snapshot.queryParams.project_id
    );
    this.selectedOverseas = this.parseArray(
      this.route.snapshot.queryParams.selectedOverseas
    );
    this.selectedEvent_ids = this.parseArray(
      this.route.snapshot.queryParams.selectedEvent_ids
    );
    this.selectedCheques = this.parseArray(
      this.route.snapshot.queryParams.selectedCheques
    );
    this.selectedBrokers = this.parseArray(
      this.route.snapshot.queryParams.selectedBrokers
    );
    this.selectedPaymentPlans = this.parseArray(
      this.route.snapshot.queryParams.selectedPaymentPlans
    );
    this.selectedTeams = this.parseArray(
      this.route.snapshot.queryParams.selectedTeams
    );

    this.uploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
  }

  generateReservationForAgent() {
    this.slimLoadingBarService.start();
    this.reservationService.generateReservationForAgent().subscribe(
      (res: any) => {},
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  private joinParam(value: any): string {
    if (Array.isArray(value)) {
      return value.join();
    }
    if (value === undefined || value === null) {
      return "";
    }
    return String(value);
  }

  private toNumber(value: any): number | null {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }

  private formatSummaryValue(value: any, fractionDigits = 2): string {
    const numericValue = this.toNumber(value);
    if (numericValue === null) {
      return "-";
    }
    return numericValue.toLocaleString(undefined, {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });
  }

  private readField(source: any, keys: string[]): any {
    if (!source) {
      return null;
    }

    for (const key of keys) {
      if (source[key] !== undefined && source[key] !== null && source[key] !== "") {
        return source[key];
      }
    }

    return null;
  }

  private updateReservationSummaryStats(response: any) {
    const summarySource =
      response &&
      (response.summary ||
        response.stats ||
        response.cards ||
        response.sold_units_summary);

    let totalUnitsPrice = this.readField(response, [
      "total_reservation_amount",
    ]);
    if (totalUnitsPrice === null) {
      totalUnitsPrice = this.readField(summarySource, [
      "total_units_price",
      "total_units_prices",
      "total_price",
      "units_total_price",
      ]);
    }

    let totalSoldUnits = this.readField(response, [
      "total_reservation_count",
    ]);
    if (totalSoldUnits === null) {
      totalSoldUnits = this.readField(summarySource, [
      "total_sold_units",
      "sold_units",
      "sold_units_count",
      "count",
      "total",
      ]);
    }

    let totalBUA = this.readField(response, [
      "total_reservation_build_area",
    ]);
    if (totalBUA === null) {
      totalBUA = this.readField(summarySource, [
      "total_bua",
      "bua",
      "total_unit_area",
      "total_building_area",
      "total_area",
      ]);
    }

    let averageUnitsMeterPrice = this.readField(response, [
      "avg_meter_price",
    ]);
    if (averageUnitsMeterPrice === null) {
      averageUnitsMeterPrice = this.readField(summarySource, [
      "average_units_meter_price",
      "avg_units_meter_price",
      "average_meter_price",
      "avg_meter_price",
      "unit_meter_price_average",
      ]);
    }

    if (
      totalUnitsPrice === null ||
      totalSoldUnits === null ||
      totalBUA === null ||
      averageUnitsMeterPrice === null
    ) {
      const reservations = (response && response.data) || [];
      if (Array.isArray(reservations) && reservations.length > 0) {
        let calculatedTotalPrice = 0;
        let calculatedTotalBUA = 0;
        let soldCount = 0;

        reservations.forEach((reservation) => {
          const unitPrice = this.toNumber(reservation && reservation.unit_price);
          const unitBUA = this.toNumber(
            reservation &&
              (reservation.unit_building_area || reservation.unit_area)
          );

          if (unitPrice !== null) {
            calculatedTotalPrice += unitPrice;
          }

          if (unitBUA !== null) {
            calculatedTotalBUA += unitBUA;
          }

          soldCount += 1;
        });

        if (totalUnitsPrice === null) {
          totalUnitsPrice = calculatedTotalPrice;
        }
        if (totalSoldUnits === null) {
          totalSoldUnits = soldCount;
        }
        if (totalBUA === null) {
          totalBUA = calculatedTotalBUA;
        }
        if (averageUnitsMeterPrice === null && calculatedTotalBUA > 0) {
          averageUnitsMeterPrice = calculatedTotalPrice / calculatedTotalBUA;
        }
      }
    }

    this.reservationSummaryStats = {
      title: "Sold Units",
      cards: [
        {
          label: "Total Units Price",
          value: this.formatSummaryValue(totalUnitsPrice),
        },
        {
          label: "Total sold units",
          value: this.formatSummaryValue(totalSoldUnits, 0),
        },
        { label: "Total BUA", value: this.formatSummaryValue(totalBUA) },
        {
          label: "Average Units Meter Price",
          value: this.formatSummaryValue(averageUnitsMeterPrice),
        },
      ],
    };
  }

  filterReservations(cache = true) {
    this.page = 1;
    let formModel = this.filterForm.value;

    if (cache) this.setQueryParams(formModel);

    formModel.agents = this.selectedAgents;
    formModel.statuses = this.selectedStatuses;
    formModel.contractStatus = this.selectedContractStatuses;
    formModel.contract_type = this.selectedContractTypes;
    formModel.grant_commission = this.selectedGrantCommissions;
    formModel.is_deposit = this.selectedDeposits;
    formModel.is_commissioned = this.selectedCommissioned;
    formModel.reservation_form_signed = this.selectedReservationFormSigned;
    formModel.is_collect_down_payment = this.selectedCollectedDownPayment;
    formModel.is_bank_transfer = this.selectedBankTransfer;
    formModel.project_id = this.joinParam(this.selectedProjects);
    formModel.overseas = this.selectedOverseas;
    formModel.event_ids = this.selectedEvent_ids;
    formModel.cheques = this.selectedCheques;
    formModel.broker_id = this.selectedBrokers;
    formModel.payment_plan_id = this.joinParam(this.selectedPaymentPlans);
    formModel.teams = this.selectedTeams;

    if (this.userProfile.role != "Admin" && this.userProfile.role != "CFO") {
      formModel.status = "Available";
    }
    formModel.is_export = 0;
    this.slimLoadingBarService.start();
    this.filterActive = true;
    this.filterData = formModel;
    this.is_refreshing = true;
    let params = {
      agents: this.joinParam(formModel.agents),
      serial: formModel.serial,
      rf_serial: formModel.rf_serial,
      contract_status: this.joinParam(formModel.contractStatus),
      grant_commission: this.joinParam(formModel.grant_commission),
      statuses: this.joinParam(formModel.statuses),
      overseas: this.joinParam(formModel.overseas),
      event_ids: this.joinParam(formModel.event_ids),
      cheques: this.joinParam(formModel.cheques),
      broker_id: this.joinParam(formModel.broker_id),
      payment_plan_id: this.joinParam(formModel.payment_plan_id),
      team_id: this.joinParam(this.selectedTeams),
      contract_type: this.joinParam(formModel.contract_type),
      lead_name: formModel.lead_name,
      location: formModel.location,
      project_id: this.joinParam(formModel.project_id),
      date_from: formModel.date_from,
      date_to: formModel.date_to,
      is_gift: formModel.is_gift,
      is_shareholder: formModel.is_shareholder,
      approve_refund_request_date_from: formModel.approve_refund_request_date_from,
      approve_refund_request_date_to: formModel.approve_refund_request_date_to,
      is_deposit: formModel.is_deposit,
      is_commissioned: formModel.is_commissioned,
      reservation_form_signed: formModel.reservation_form_signed,
      is_collect_down_payment: formModel.is_collect_down_payment,
      is_bank_transfer: formModel.is_bank_transfer,
    };
    this.reservationService
      .filterReservations(params)
      .subscribe((data: any) => {
        console.log({ data });
        let selected = true;
        this.reservation_raw_data = data;
        this.pagination = [];
        this.last_page_url = data.last_page_url;
        this.current_page = 1;
        this.totalRec = data.total;
        this.reservations = data.data;
        this.updateReservationSummaryStats(data);
        this.per_page = data.to;
        this.total = data.total;
        for (var i = 1; i <= data.last_page; i++) {
          if (i > 1) selected = false;
          this.pagination.push({ number: i, selected: selected });
        }
        this.reservations = data.data;
        this.slimLoadingBarService.complete();
        this.is_refreshing = false;
      }),
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
        this.is_refreshing = false;
      },
      () => {};
    console.log(formModel);
  }

  exportTable() {
    let formModel = this.filterForm.value;

    formModel.agents = this.selectedAgents;
    formModel.statuses = this.selectedStatuses;
    formModel.contractStatus = this.selectedContractStatuses;
    formModel.contract_type = this.selectedContractTypes;
    formModel.grant_commission = this.selectedGrantCommissions;
    formModel.is_deposit = this.selectedDeposits;
    formModel.is_commissioned = this.selectedCommissioned;
    formModel.reservation_form_signed = this.selectedReservationFormSigned;
    formModel.is_collect_down_payment = this.selectedCollectedDownPayment;
    formModel.is_bank_transfer = this.selectedBankTransfer;
    formModel.project_id = this.joinParam(this.selectedProjects);
    formModel.overseas = this.selectedOverseas;
    formModel.event_ids = this.selectedEvent_ids;
    formModel.cheques = this.selectedCheques;
    formModel.broker_id = this.selectedBrokers;
    formModel.payment_plan_id = this.joinParam(this.selectedPaymentPlans);
    formModel.teams = this.selectedTeams;

    if (this.userProfile.role != "Admin" && this.userProfile.role != "CFO") {
      formModel.status = "Available";
    }

    formModel.is_export = 1;

    let params = {
      agents: this.joinParam(formModel.agents),
      serial: formModel.serial,
      rf_serial: formModel.rf_serial,
      contract_status: this.joinParam(formModel.contractStatus),
      grant_commission: this.joinParam(formModel.grant_commission),
      statuses: this.joinParam(formModel.statuses),
      overseas: this.joinParam(formModel.overseas),
      event_ids: this.joinParam(formModel.event_ids),
      cheques: this.joinParam(formModel.cheques),
      broker_id: this.joinParam(formModel.broker_id),
      payment_plan_id: this.joinParam(formModel.payment_plan_id),
      team_id: this.joinParam(this.selectedTeams),
      contract_type: this.joinParam(formModel.contract_type),
      lead_name: formModel.lead_name,
      location: formModel.location,
      project_id: this.joinParam(formModel.project_id),
      date_from: formModel.date_from,
      date_to: formModel.date_to,
      is_gift: formModel.is_gift,
      is_shareholder: formModel.is_shareholder,
      approve_refund_request_date_from: formModel.approve_refund_request_date_from,
      approve_refund_request_date_to: formModel.approve_refund_request_date_to,
      is_deposit: formModel.is_deposit,
      is_commissioned: formModel.is_commissioned,
      reservation_form_signed: formModel.reservation_form_signed,
      is_collect_down_payment: formModel.is_collect_down_payment,
      is_bank_transfer: formModel.is_bank_transfer,
      is_export: formModel.is_export,
    };
    this.slimLoadingBarService.start();
    this.reservationService.exportTable(params).subscribe((data: any) => {
      window.open(data, "_blank");
      this.slimLoadingBarService.complete();
    }),
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      };
  }

  exportAll() {
    this.reservationService.exportTable().subscribe((data: any) => {
      window.open(data, "_blank");
      this.slimLoadingBarService.complete();
    }),
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      };
  }

  exportFilteredToERP() {
    let formModel = this.filterForm.value;

    formModel.agents = this.selectedAgents;
    formModel.statuses = this.selectedStatuses;
    formModel.contractStatus = this.selectedContractStatuses;
    formModel.contract_type = this.selectedContractTypes;
    formModel.grant_commission = this.selectedGrantCommissions;
    formModel.is_deposit = this.selectedDeposits;
    formModel.is_commissioned = this.selectedCommissioned;
    formModel.reservation_form_signed = this.selectedReservationFormSigned;
    formModel.is_collect_down_payment = this.selectedCollectedDownPayment;
    formModel.is_bank_transfer = this.selectedBankTransfer;
    formModel.project_id = this.joinParam(this.selectedProjects);
    formModel.overseas = this.selectedOverseas;
    formModel.event_ids = this.selectedEvent_ids;
    formModel.cheques = this.selectedCheques;
    formModel.broker_id = this.selectedBrokers;
    formModel.payment_plan_id = this.joinParam(this.selectedPaymentPlans);
    formModel.team_id = this.joinParam(this.selectedTeams);

    if (this.userProfile.role != "Admin" && this.userProfile.role != "CFO") {
      formModel.status = "Available";
    }

    formModel.send_to_erp = 1;

    this.slimLoadingBarService.start();
    this.reservationService.exportTable(formModel).subscribe((data: any) => {
      swal("success", "", "success");
      this.slimLoadingBarService.complete();
    }),
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      };
  }

  resetFilters() {
    this.filterActive = false;
    this.filterData = null;
    // this.createForms();
    this.getreservations();
    // this.filterForm.reset();
    this.filterForm.patchValue({
      serial: [""],
      rf_serial: [""],
      agents: [[]],
      lead_name: [""],
      location: [""],
      contractStatuses: [[]],
      contract_type: [[]],
      statuses: [[]],
      overseas: [[]],
      event_ids: [[]],
      cheques: [[]],
      project_id: [""],
      // selling_date: [''],
      is_gift: "",
      is_shareholder: "",
      is_deposit: [[]],
      is_commissioned: [[]],
      reservation_form_signed: [[]],
      is_collect_down_payment: [[]],
    });
    this.selectedAgents = [];
    this.selectedStatuses = [];
    this.selectedContractStatuses = [];
    this.selectedContractTypes = [];
    this.selectedGrantCommissions = [];
    this.selectedDeposits = [];
    this.selectedCommissioned = [];
    this.selectedReservationFormSigned = [];
    this.selectedBankTransfer = [];
    this.selectedProjects = [];
    this.selectedOverseas = [];
    this.selectedEvent_ids = [];
    this.selectedCheques = [];
    this.selectedBrokers = [];
    this.selectedPaymentPlans = [];
    this.selectedTeams = [];
    this.resetQueryParams();
  }

  handleReceiptFile(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name = file.name;
      reader.onload = () => {
        this.filesForm.get("receipt").setValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  infinite(url, number) {
    this.slimLoadingBarService.start();
    this.is_refreshing = true;
    this.leadsService.infinit(url).subscribe(
      (data: any) => {
        this.reservation_raw_data = data;
        this.totalRec = data.total;
        this.reservations = data.data;
        this.updateReservationSummaryStats(data);
        this.current_page = number;
        this.per_page = data.to;
        this.total = data.total;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      },
      () => (this.is_refreshing = false)
    );
  }

  paginate(number) {
    // this.pagination.forEach(element => {
    //   if (element.number == number) {
    //     element.selected = true;
    //     let arr = this.last_page_url.split('?');
    //     if (this.current_page != number) {
    //       let selectedUrl = `${arr[0]}?page=${number}`;
    //       console.log(selectedUrl);
    //     }
    //     // console.log(arr);
    //   }
    //   else element.selected = false;
    // });
  }

  handleSignedFile(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name2 = file.name;
      reader.onload = () => {
        this.filesForm.get("signed").setValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  actionOnOpen(reservationId) {
    console.log(reservationId);
  }

  actionOnClose() {}

  actionOnSubmit(reservationId, modal) {
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    const formModel = this.filesForm.value;
    console.log(formModel);
    if (!formModel.receipt || !formModel.signed) {
      swal("Oops...", "Files can not be empty!", "error");
    } else {
      let data = {
        receipt: formModel.receipt.value,
        scan_url: formModel.signed.value,
        id: reservationId,
        file_name2: formModel.signed.filename,
        file_name: formModel.receipt.filename,
      };
      console.log(data);
      this.reservationService.contractorApproved(data).subscribe(
        (data) => {
          console.log(data);
          this.slimLoadingBarService.complete();
          modal.close();
          swal("Woohoo!", "Contractor Approved!", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
    }
  }

  infiniteWithFilter(url, number) {
    this.slimLoadingBarService.start();
    this.is_refreshing = true;
    let params = {
      agents: this.joinParam(this.filterData.agents),
      serial: this.filterData.serial,
      rf_serial: this.filterData.rf_serial,
      contract_status: this.joinParam(this.filterData.contractStatus),
      grant_commission: this.joinParam(this.filterData.grant_commission),
      statuses: this.joinParam(this.filterData.statuses),
      overseas: this.joinParam(this.filterData.overseas),
      event_ids: this.joinParam(this.filterData.event_ids),
      cheques: this.joinParam(this.filterData.cheques),
      broker_id: this.joinParam(this.filterData.broker_id),
      payment_plan_id: this.joinParam(this.filterData.payment_plan_id),
      team_id: this.joinParam(this.filterData.teams || this.selectedTeams),
      contract_type: this.joinParam(this.filterData.contract_type),
      lead_name: this.filterData.lead_name,
      location: this.filterData.location,
      project_id: this.joinParam(this.filterData.project_id),
      date_from: this.filterData.date_from,
      date_to: this.filterData.date_to,
      is_gift: this.filterData.is_gift,
      is_shareholder: this.filterData.is_shareholder,
      approve_refund_request_date_from: this.filterData.approve_refund_request_date_from,
      approve_refund_request_date_to: this.filterData.approve_refund_request_date_to,
      is_deposit: this.filterData.is_deposit,
      is_commissioned: this.filterData.is_commissioned,
      reservation_form_signed: this.filterData.reservation_form_signed,
      is_collect_down_payment: this.filterData.is_collect_down_payment,
      is_bank_transfer: this.filterData.is_bank_transfer,
    };
    this.reservationService
      .infinitWithPagination(url, params)
      .subscribe(
        (data: any) => {
          this.reservation_raw_data = data;
          this.totalRec = data.total;
          this.reservations = data.data;
          this.updateReservationSummaryStats(data);
          this.current_page = number;
          this.per_page = data.to;
          this.total = data.total;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        },
        () => (this.is_refreshing = false)
      );
  }

  accountDecline(reservationId) {
    swal({
      title: "Are you sure?",
      text: "You will decline the reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .accountDeclineReservation(reservationId)
          .subscribe(
            (data) => {
              console.log(data);
              this.getreservations();
              swal("Woohoo!", "Declined succesfully!", "success");
            },
            (err) => this.errorHandlerService.handleErorr(err),
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  declineReservation(reservationId) {
    this.slimLoadingBarService.start();
    this.reservationService.adminDeclineReservations(reservationId).subscribe(
      (data) => {
        console.log(data);
        this.getreservations();
        swal("Woohoo!", "Approved succesfully!", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  closeAssignModal() {}

  swalDelete(res_id) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService.deleteReservation(res_id).subscribe(
          (data) => {
            this.slimLoadingBarService.complete();
            swal("Deleted!", "Reservation has been deleted.", "success");
            this.getreservations();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  submitAssignModal(res_id, modal) {
    this.slimLoadingBarService.start();
    this.reservationService.assignToLead(res_id, this.chosenAgent.id).subscribe(
      (data) => {
        console.log(data);
        swal("Woohoo!", "Assigned to user successfully!", "success");
        this.getreservations();
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  openAssignModal(unit_id) {}

  unitOnOpen(unit_id) {
    console.log(unit_id);
    this.projectService.getUnitDetails(unit_id).subscribe(
      (data) => {
        console.log(data);
        this.units_reservation_modal_data = data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  unitModalOnClose() {}

  /**
   * Start of Installment Modal
   */

  createInstallment() {
    this.installmentForm = this.fb.group({
      percentage: ["", Validators.required],
      slots: ["0", Validators.required],
      type: ["6 years", Validators.required],
      day: ["5", Validators.required],
      doc_type: ["PDF", Validators.required],
      installment_plan: ["Quarter", Validators.required],
    });
  }

  openInstallmentModal(reservation) {}

  closeInstallmentModal(reservation) {}

  submitInstallmentModal(reservation, modal) {
    let data = this.installmentForm.value;
    data.r_serial = reservation.id;
    data.rf_serial = reservation.unit.serial;
    console.log(data);
    /* call back end point here and dismiss loader in success */
    this.is_installment_modal_loading = true;
    this.reservationService.installmentPdf(data).subscribe(
      (res: any) => {
        modal.close();
        console.log(res.url);
        window.open(res.url);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => (this.is_installment_modal_loading = false)
    );
  }

  /**
   * End of Installment Modal
   */

  // contract_sign_by_client(reservation_id) {
  //   swal({
  //     title: 'Are you sure?',
  //     text: 'client signed contract!',
  //     type: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'No'
  //   }).then(result => {
  //     if (result.value) {
  //       this.slimLoadingBarService.start();
  //       this.reservationService
  //         .contract_sign_by_client(reservation_id)
  //         .subscribe(
  //           data => {
  //             this.getreservations();
  //             swal(
  //               'Woohoo!',
  //               'Contract signed by client succesfully!',
  //               'success'
  //             );
  //           },
  //           err => console.log(err),
  //           () => this.slimLoadingBarService.complete()
  //         );
  //     } else if (result.dismiss) {
  //       swal('Cancelled', '', 'error');
  //     }
  //   });
  // }

  // contract_approve(reservation_id) {
  //   swal({
  //     title: 'Are you sure?',
  //     text: 'Approve the contract!',
  //     type: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'No'
  //   }).then(result => {
  //     if (result.value) {
  //       this.slimLoadingBarService.start();
  //       this.reservationService.contract_approve(reservation_id).subscribe(
  //         data => {
  //           this.getreservations();
  //           swal('Woohoo!', 'Contract approved succesfully!', 'success');
  //         },
  //         err => console.log(err),
  //         () => this.slimLoadingBarService.complete()
  //       );
  //     } else if (result.dismiss) {
  //       swal('Cancelled', '', 'error');
  //     }
  //   });
  // }

  // contract_delivered(reservation_id) {
  //   swal({
  //     title: 'Are you sure?',
  //     text: 'Contract Delivered!',
  //     type: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'No'
  //   }).then(result => {
  //     if (result.value) {
  //       this.slimLoadingBarService.start();
  //       this.reservationService.contract_delivered(reservation_id).subscribe(
  //         data => {
  //           this.getreservations();
  //           swal('Woohoo!', 'Contract delivered succesfully!', 'success');
  //         },
  //         err => console.log(err),
  //         () => this.slimLoadingBarService.complete()
  //       );
  //     } else if (result.dismiss) {
  //       swal('Cancelled', '', 'error');
  //     }
  //   });
  // }

  cheque_recieved(reservation_id) {
    // swal({
    //   title: 'Are you sure?',
    //   text: 'cheque Recieved!',
    //   type: 'warning',
    //   showCancelButton: true,
    //   confirmButtonText: 'Yes',
    //   cancelButtonText: 'No'
    // }).then(result => {
    //   if (result.value) {
    //     this.slimLoadingBarService.start();
    //     this.reservationService.cheque_recieved(reservation_id).subscribe(
    //       data => {
    //         this.getreservations();
    //         swal('Woohoo!', 'cheque Recieved succesfully!', 'success');
    //       },
    //       err => console.log(err),
    //       () => this.slimLoadingBarService.complete()
    //     );
    //   } else if (result.dismiss) {
    //     swal('Cancelled', '', 'error');
    //   }
    // });
  }

  /**
   * Start of Comment Modal
   * */
  openCommentModal(reservation) {}

  submitCommentModal(reservation_id, modal) {
    if (!this.commentReservation)
      swal("Error", "Comment can not be empty", "error");
    else {
      this.slimLoadingBarService.start();
      this.reservationService
        .addReservationComment(reservation_id, this.commentReservation)
        .subscribe(
          (data) => {
            modal.close();
            this.getreservations();
            swal("Woohoo!", "Comment have added succesfully!", "success");
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  closeCommentModal() {}

  openViewCommentModal(reservation) {}

  closeViewCommentModal() {}

  /**
   * End of Comment Modal
   */

  /**
   * Start of Lead Modal
   */

  leadModalOnOpen(reservation) {}

  leadModalOnClose(reservation) {}

  goToEditLead(reservation, modal) {
    if (
      this.userProfile.role == "Admin" ||
      this.userProfile.role == "CFO" ||
      reservation.user.id == this.userProfile.id
    ) {
      this.router.navigate(["/pages/addLead/", reservation.lead.id]);
      modal.close();
    } else {
      swal("Access Deined", "", "error");
    }
  }

  redirectToLeadDetails(leadId) {
    if (!isNaN(leadId)) {
      // this.router.navigate([`/pages/leads/${leadId}`]);
      this.router.navigate(["/pages/leads"], {
        queryParams: {
          lead_id: leadId,
        },
      });
    }
    return;
  }

  submitChangeSignatureModal(reservation, modal) {
    if (!this.signature_date) {
      swal("Signature date can not be empty", "", "error");
    } else {
      this.slimLoadingBarService.start();
      this.reservationService
        .changeSignatureDate(reservation.id, this.submitCommentModal)
        .subscribe(
          (data: any) => {
            swal("Signature date Changed successfully", "", "success");
            modal.close();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /**
   * End of Change Signature Modal
   */

  /**
   * Start of edit selling price modal
   */
  openEditSellingPriceModal(reservation) {}

  closeEditSellingPriceModal() {}

  submiteditSellingPriceModal(reservation, modal) {
    if (!this.selling_price)
      swal("Selling price can not be empty", "", "error");
    else {
      this.slimLoadingBarService.start();
      this.reservationService
        .editSellingPrice(reservation.id, { selling_price: this.selling_price })
        .subscribe(
          (data: any) => {
            swal("Selling price changes successfully", "", "success");
            modal.close();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  pageChange(event) {
    this.page = event;
    let arr = this.last_page_url.split("?");
    let selectedUrl = `${arr[0]}?page=${event}&page_length=${this.page_length}`;
    if (this.filterActive) {
      this.infiniteWithFilter(selectedUrl, event);
    } else {
      this.infinite(selectedUrl, event);
    }
  }

  changePageLength(page_length) {
    this.page_length = page_length;
    this.page = 1;
    let arr = this.last_page_url.split("?");
    let selectedUrl = `${arr[0]}?page=${this.page}&page_length=${this.page_length}`;
    if (this.filterActive) {
      this.infiniteWithFilter(selectedUrl, this.page);
    } else {
      this.infinite(selectedUrl, this.page);
    }
  }

  toggleChange($event, type) {
    console.log($event, type);
    this.manageTable[type] = !$event;
  }

  submitChangeSellingDateModal(reservation, modal) {
    if (!this.selling_date) swal("Selling date can not be empty", "", "error");
    else {
      let data = {
        date: this.selling_date,
      };
      this.slimLoadingBarService.start();
      this.reservationService.changeSellingDate(reservation.id, data).subscribe(
        (data) => {
          modal.close();
          swal("Selling date changed successfully", "", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  accountantApproveModalOpen(reservation) {}

  accountApprove(reservation, modal) {
    if (this.is_edit_mode_account_approve) {
      if (!this.cfo_pin)
        swal("Finance manager pin can not be empty.", "", "error");
      else {
        // call back end point
        let data = {
          price: reservation.unit_price,
          is_edit_mode: true,
          cfo_pin: this.cfo_pin,
        };
        this.slimLoadingBarService.complete();
        this.reservationService
          .accountantApprove(reservation.id, data)
          .subscribe(
            (data) => {
              swal("Accountant approved successfully", "", "success");
              modal.close();
            },
            (err) => this.errorHandlerService.handleErorr(err),
            () => this.slimLoadingBarService.complete()
          );
      }
    } else {
      // call back end point
      let data = {
        price: reservation.unit_price,
        is_edit_mode: false,
      };
      this.slimLoadingBarService.complete();
      this.reservationService.accountantApprove(reservation.id, data).subscribe(
        (data) => {
          swal("Accountant approved successfully", "", "success");
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  editPrice(last_price) {
    this.last_price = last_price;
    this.is_edit_mode_account_approve = true;
  }

  closeEditPrice(i) {
    console.log(i);
    this.reservations[i].unit_price = this.last_price;
    this.is_edit_mode_account_approve = false;
  }

  /**
   * End of accountant approve modal
   */

  /**
   * Start of import reservation modal
   */

  importReservationModalOpen() {}

  importReservationModalClose() {
    this.createForms();
    let inputValue = (<HTMLInputElement>document.getElementById("file")).value;
    inputValue = "";
  }

  uploadExcelMethod(modal) {
    let formValue = this.uploadExcel.value;
    let data = {
      file_name: formValue.file.file_name,
      file_value: formValue.file.file_value,
    };
    this.slimLoadingBarService.start();
    this.reservationService.importReservation(data).subscribe(
      (data) => {
        this.createForms();
        this.getreservations();
        let inputValue = (<HTMLInputElement>document.getElementById("file"))
          .value;
        inputValue = "";
        modal.close();
        swal("Reservations imported successfully", "", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  handleUploadExcel(event) {
    console.log(event);
    console.log(event.target.files);
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      reader.onload = () => {
        this.uploadExcel.get("file").setValue({
          file_name: file.name,
          file_value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  /**
   * End of import reservation modal
   */

  viewReservation(reservation) {
    window.localStorage.setItem(
      "reservationDetails",
      JSON.stringify(reservation)
    );
    const role = this.userProfile.role;
    if (
      role == "Helpdesk Supervisor" ||
      role == "Helpdesk Agent" ||
      role == "Call Center" ||
      role == "Helpdesk Agent" ||
      role == "RF Viewer"
    ) {
      this.router.navigate(["/pages/project/view-reservation"], {
        queryParams: {
          ro: 1,
        },
      });
    } else {
      this.router.navigate(["/pages/project/view-reservation"]);
    }
  }

  downloadUnitStatement(id) {
    this.slimLoadingBarService.start();
    this.reservationService.getUnitStatement(id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        window.open(res.url);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  /**
   * start of re-assign client modal
   */

  reAssignClientModalOpen(reservation) {}

  observableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .post(`${baseUrl}leads/search`, JSON.stringify(data))
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.leadArrSerach = [];
            this.dataFromSearch = res.data;
            res.data.forEach((e) => {
              this.leadArrSerach.push(e.name);
            });
            return this.leadArrSerach;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  getLeadDetails(): any {
    console.log(this.chosenLead);
    if (!this.chosenLead) {
      swal("Lead name can not be empty!");
    } else {
      if (this.dataFromSearch.length == 0) {
        swal("No Lead with that name.");
      } else {
        let found = false;
        console.log(this.dataFromSearch);
        this.dataFromSearch.forEach((element) => {
          if (element.name == this.chosenLead) {
            this.chosenLeadID = element.id;
            found = true;
          }
        });
        if (!found) swal("No Lead with that name.");
      }
    }
  }

  searchLeadSelected(event) {
    console.log(event);
  }

  reAssignClientModalClose() {}

  reAssignClientSubmit(reservation, modal) {
    if (!this.chosenLeadID)
      swal(
        "Lead ID can not be empty",
        "click on get info button to get the lead id.",
        "error"
      );
    else if (!this.chosenLeadPhone) swal("Lead Phone can not be empty");
    else if (!this.chosenLeadName)
      swal("Lead Name can not be empty", "", "error");
    else if (!this.chosenLeadReason)
      swal("Reason can not be empty", "", "error");
    else {
      //call the back end point
      let data = {
        lead_id: this.chosenLeadID,
        reservation_id: reservation.id,
        reason: this.chosenLeadReason,
        lead_name: this.chosenLeadName,
        lead_phone: this.chosenLeadPhone,
      };
      this.slimLoadingBarService.start();
      this.reservationService.reAssignToLead(data).subscribe(
        (res) => {
          this.getreservations();
          swal("Re-assign reservation to client successfully", "", "success");
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  /**
   * end of re-assign client modal
   */

  downloadReservation(id) {
    this.slimLoadingBarService.start();
    this.reservationService.downloadReservation(id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        window.open(res.url);
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  // cache table
  columns = [
    { key: "id", name: "ID" },
    { key: "lead_name", name: "Lead Name" },
    { key: "unit_serial", name: "Unit Serial" },
    { key: "project", name: "Project" },
    { key: "status", name: "Status" },
    { key: "admin_confirmation", name: "Admin Confirmation" },
    { key: "unit_area", name: "Unit Area" },
    { key: "garden_area", name: "Garden Area" },
    { key: "land_area", name: "Land Area" },
    { key: "roof_area", name: "Roof Area" },
    { key: "contract_type", name: "Contract Type" },
    { key: "finishing_type", name: "Finishing Type" },
    { key: "price", name: "Price" },
    { key: "agent", name: "Agent" },
    { key: "event", name: "Event" },
    { key: "location", name: "Location" },
    { key: "date", name: "Date" },
    { key: "selling_date", name: "Selling Date" },
    { key: "contract_generated", name: "Contract Generated" },
    { key: "is_deposit", name: "Is Deposit" },
    { key: "is_commissioned", name: "Is Commissioned" },
    { key: "is_reservation_gift", name: "Reservation Gift" },
    { key: "reservation_form_signed", name: "Is Reservation Form Signed" },
    { key: "is_bank_transfer", name: "Is Bank Transfer" },
  ];

  manageTable = {};

  onSelectColumns(columns) {
    this.manageTable = columns;
  }

  // cache filters
  setQueryParams(params = {}) {
    let data: any = {};

    [
      "serial",
      "rf_serial",
      "lead_name",
      "location",
      "project_id",
      "date_from",
      "date_to",
      "is_gift",
      "is_shareholder",
      "approve_refund_request_date_from",
      "approve_refund_request_date_to",
    ].map((f) => {
      if (params[f] !== null && params[f] !== undefined && params[f] !== "") {
        data[f] = params[f];
      }
    });

    if (this.selectedAgents.length > 0) {
      data.selectedAgents = this.selectedAgents;
    }
    if (this.selectedStatuses.length > 0) {
      data.selectedStatuses = this.selectedStatuses;
    }

    if (this.selectedContractStatuses.length > 0) {
      data.selectedContractStatuses = this.selectedContractStatuses;
    }
    if (this.selectedContractTypes.length > 0) {
      data.selectedContractTypes = this.selectedContractTypes;
    }
    if (this.selectedGrantCommissions.length > 0) {
      data.selectedGrantCommissions = this.selectedGrantCommissions;
    }

    if (this.selectedDeposits.length > 0) {
      data.selectedDeposits = this.selectedDeposits;
    }
    if (this.selectedCommissioned.length > 0) {
      data.selectedCommissioned = this.selectedCommissioned;
    }
    if (this.selectedReservationFormSigned.length > 0) {
      data.selectedReservationFormSigned = this.selectedReservationFormSigned;
    }
    if (this.selectedBankTransfer.length > 0) {
      data.selectedBankTransfer = this.selectedBankTransfer;
    }
    if (this.selectedProjects.length > 0) {
      data.selectedProjects = this.selectedProjects;
    }

    if (this.selectedOverseas.length > 0) {
      data.selectedOverseas = this.selectedOverseas;
    }
    if (this.selectedEvent_ids.length > 0) {
      data.selectedEvent_ids = this.selectedEvent_ids;
    }
    if (this.selectedCheques.length > 0) {
      data.selectedCheques = this.selectedCheques;
    }
    if (this.selectedBrokers.length > 0) {
      data.selectedBrokers = this.selectedBrokers;
    }
    if (this.selectedPaymentPlans.length > 0) {
      data.selectedPaymentPlans = this.selectedPaymentPlans;
    }
    if (this.selectedTeams.length > 0) {
      data.selectedTeams = this.selectedTeams;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: data,
      replaceUrl: true,
    });
  }

  resetQueryParams() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      replaceUrl: true,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reservation/reservation.component.ts